<template>
  <div>
    <van-nav-bar
      style="background: #ffffff; color: #323233; font-weight: bold"
      fixed
      :title="nodename"
      left-arrow
      @click-left="onClickLeft"
    />
    <div id="aaa"></div>

    <van-cell-group title="影像中心" :border="false" style="margin-left: 10px">
      <van-cell
        icon="location-o"
        :value="currentAgent.name"
        style="border-bottom: 0.1px solid #f5f5f5"
      />
    </van-cell-group>
    <van-cell-group
      title="盘点单号"
      :border="false"
      style="margin-left: 10px"
    >
      <van-cell
        icon="orders-o"
        :value="inventoryNum"
        style="border-bottom: 0.1px solid #f5f5f5"
      />
    </van-cell-group>

    <van-cell-group title="备注" :border="false" style="margin-left: 10px">
      <van-cell icon="edit" style="border-bottom:0.1px solid 	#F5F5F5">
        <van-field
          v-model="remark"
          rows="2" 
          :disabled="!isFirstNode || !permission"
          autosize
          type="textarea"
          maxlength="110"
          placeholder="填写备注"
        />
      </van-cell>
      <!-- <van-cell style="border-bottom: 0.1px solid #f5f5f5" :value="remark" /> -->
    </van-cell-group>

    <van-cell-group :title="titlename" :border="false">
      <van-cell
        v-for="(item, index) in inventoryDetailArr"
        :key="index" 
        :class="{discolor:index%2==0}"
      >
        <van-row type="flex" justify="space-between">
          <van-col span="3">类别:</van-col>
          <van-col span="11">{{ item.catname }}</van-col>
          <van-col span="3" offset="2">品牌:</van-col>
          <van-col span="5">{{ item.bname }}</van-col>
        </van-row>
        <van-row type="flex">
          <van-col span="3">型号:</van-col>
          <van-col span="19">{{ item.sname }}</van-col>
        </van-row>
        <van-row type="flex" justify="space-between">
          <van-col span="3">库存:</van-col>
          <van-col span="11">{{ item.stock_num }}</van-col>
          <van-col span="3" offset="2">单位:</van-col>
          <van-col span="5">{{ item.unit }}</van-col>
        </van-row>
        <van-row type="flex">
          <van-col span="3" style="color:red;">实盘:</van-col>
          <van-col span="11">
            <van-field 
              v-model="item.actual_num" 
              :disabled="!isFirstNode || !permission" 
              border 
              style="border:1px solid #DCDCDC" 
              placeholder="请输入实际盘点数量" 
              type="digit" 
            />
          </van-col>
        </van-row>
        <van-row type="flex" v-if="item.stock_num != item.actual_num">
          <van-col span="3" v-if="item.stock_num < item.actual_num">盘盈:</van-col>
          <van-col span="11" v-if="item.stock_num < item.actual_num">{{ item.actual_num - item.stock_num }}</van-col>
          <van-col span="3" v-if="item.stock_num > item.actual_num">盘亏:</van-col>
          <van-col span="5" v-if="item.stock_num > item.actual_num">{{ item.stock_num - item.actual_num }}</van-col>
        </van-row>
        <van-row type="flex" v-if="item.stock_num != item.actual_num">
          <van-col span="3" >备注:</van-col>
          <van-col span="11">
            <van-field v-model="item.remarks" 
              :disabled="!isFirstNode || !permission" 
              border 
              style="border:1px solid #DCDCDC" 
              placeholder="请输入差异原因"
            />
          </van-col>
        </van-row>
        
        <van-row type="flex" v-if="item.stock_num != item.actual_num">
          <van-col span="22">上传证明文件:</van-col>
        </van-row>
        <van-row type="flex" v-if="item.stock_num != item.actual_num">
          <van-uploader v-model="item.prove_file"
            :max-count="1" 
            :after-read="afterRead" 
            :deletable="isFirstNode" 
            :disabled="!isFirstNode || !permission"
          />
        </van-row>
      </van-cell>
    </van-cell-group>

    <van-cell-group v-if="permission" title="操作">
      <van-cell>
        <van-row type="flex">
          <van-col span="10" v-if="isFirstNode">
            <van-button
              round
              type="info"
              @click="baocun"
            >保存</van-button>
          </van-col>
          <van-col span="2" v-if="isFirstNode"></van-col>
          <van-col span="10">
            <van-button
              round
              type="info"
              @click="tijiao"
            >提交</van-button>
          </van-col>
          <van-col span="2" v-if="!isFirstNode"></van-col>
          <van-col span="10" v-if="!isFirstNode">
            <van-button
              round
              type="info"
              @click="tuihui"
            >退回</van-button>
          </van-col>
        </van-row>
      </van-cell>
    </van-cell-group>
    
    <div
      v-show="bottom_tip"
      style="font-size: 10px; text-align: center; padding: 10px 10px"
    >
      ©2020 一脉阳光集团信息中心
    </div>
  </div>
</template>
<script>
import {
  NavBar,
  Tag,
  Image,
  DropdownMenu,
  DropdownItem,
  Col,
  Row,
  Panel,
  Divider,
  Button,
  Dialog,
  Toast,
  Uploader,
} from "vant";
import { mapState, mapMutations } from "vuex";
import axios from "axios";
export default {
  components: {
    [NavBar.name]: NavBar,
    [Tag.name]: Tag,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Col.name]: Col,
    [Image.name]: Image,
    [Toast.name]: Toast,
    [Button.name]: Button,
    [Dialog.Component.name]: Dialog.Component,
    [Panel.name]: Panel,
    [Divider.name]: Divider,
    [Row.name]: Row,
    [Uploader.name]: Uploader,
  },
  data() {
    return {
      bottom_tip: true,
      nodeId: '',
      erp:'',
      nodename: "",
      titlename:"盘点明细",
      inventoryNum: "",
      remark: "",
      inventoryDetailArr: [],
      //当前选中的影像中心
      currentAgent: "",
      mainId:"",
      permission:'',
      isFirstNode:'',
    };
  },

  methods: {
    ...mapMutations(["changePermissionAgent", "changeDefaultAgentIndex"]),
    onClickLeft() {
      this.$router.push({
        name: "inventory",
        query: {
          ms: this.$route.query.ms,
          warehouse: this.$route.query.warehouse,
          node: this.$route.query.node,
          isall:this.$route.query.isall,
        },
      });
    },
    handleAjax(instance, id) {
      instance.$http
        .post("/mobile/inventory/detailList", {
          mainid: id,
          mobile: localStorage.getItem("usermobile")
        })
        .then(function (response) {
          // window.console.log(response.record);
          instance.mainId = response.record.main.id;
          instance.nodeId = response.record.main.currentnode;
          instance.erp = response.record.main.project_code;
          instance.nodename = response.record.main.nodename;
          instance.inventoryNum = response.record.main.inventory_num;
          instance.remark = response.record.main.remarks;
          instance.inventoryDetailArr = response.record.detail;
          instance.permission = response.permission;
          instance.isFirstNode = response.is_first_node;
          //window.console.log(instance.permission);
        });
    },
    checkData(obj) {
      let newarr = [];
      let message = "";
      for (let i = 0; i < obj.length; i++) {
        if (!obj[i].actual_num && obj[i].actual_num !== 0) {
          let num = i + 1;
          //message = message + "第" + num + "条明细,实盘数量未填写;";
          message = message + "序号:" + num + "实盘数量未填写;";
          
        }
        let newobj = {
          inventoryNum: obj[i].inventory_num,
          modelUuid: obj[i].model_uuid,
          actualNum: obj[i].actual_num,
          proveFile: obj[i].prove_file,
          remarks: obj[i].remarks,
        };
        newarr.push(newobj);
      }
      return {
        message: message,
        data: newarr,
      };
    },
    afterRead(file) {
      // 此时可以自行将文件上传至服务器
      var formData = new FormData(); //构造一个 FormData，把后台需要发送的参数添加
      formData.append("file", file.file); //接口需要传的参数
      file.status = "uploading";
      file.message = "上传中...";
      axios
        .post("/api/mobile/uploadFile", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            token: localStorage.getItem("userToken"),
          },
        })
        .then((res) => {
          let img = res.data.data.replace(/storage/i, "public");
          file.url = img;
          file.status = "success";
          file.message = "上传成功";
        })
        .catch((err) => {
          file.status = "failed";
          file.message = "上传失败";
          window.console.log(err);
        });
    },
    tijiao() {
      let that = this;
      Dialog.confirm({
        message: "确认提交",
      })
        .then(() => {
          let result = that.checkData(that.inventoryDetailArr);
          if (result.message) {
            Toast(result.message);
            return;
          } else {
            let data = {
              mainid: that.$route.query.id,
              nodeid: that.nodeId,
              remark: that.remark,
              erp: that.erp,
              user: localStorage.getItem("usermobile"),
              detail: result.data,
            };
            Toast.loading({
              message: "加载中...",
              forbidClick: true,
            });
            that.$http({
              method: "post",
              url: "/mobile/inventory/submitNode",
              data,
            }).then(function (response) {
              if (response.state == 200) {
                Toast.success("提交成功");
                that.$router.push("inventory");
              }
            });
          }
        })
        .catch(() => {});
    },
    tuihui() {
      let that = this;
      Dialog.confirm({
        message: "确认退回",
      })
        .then(() => {
          let result = that.checkData(that.inventoryDetailArr);
          if (result.message) {
            Toast(result.message);
            return;
          } else {
            let data = {
              mainid: that.$route.query.id,
              nodeid: that.nodeId,
              remark: that.remark,
              erp: that.erp,
              user: localStorage.getItem("usermobile"),
              detail: result.data,
            };
            Toast.loading({
              message: "加载中...",
              forbidClick: true,
            });
            that.$http({
              method: "post",
              url: "/mobile/inventory/returnNode",
              data,
            }).then(function (response) {
              if (response.state == 200) {
                Toast.success("退回成功");
                that.$router.push("inventory");
              }
            });
          }
        })
        .catch(() => {});
    },
    baocun() {
      //window.console.log(this.inventoryDetailArr);
      let that = this;
      Dialog.confirm({
        message: "确认保存",
      })
        .then(() => {
          let result = that.checkData(that.inventoryDetailArr);
          if (result.message) {
            Toast(result.message);
            return;
          } else {
            let data = {
              mainid: that.$route.query.id,
              nodeid: that.nodeId,
              remark: that.remark,
              erp: that.erp,
              user: localStorage.getItem("usermobile"),
              detail: result.data,
            };
            Toast.loading({
              message: "加载中...",
              forbidClick: true,
            });
            that.$http({
              method: "post",
              url: "/mobile/inventory/preserveNode",
              data,
            }).then(function (response) {
              if (response.state == 200) {
                Toast.success("保存成功");
                that.$router.push("inventory");
              }
            });
          }
        })
        .catch(() => {});
    },
  },
  computed: {
    ...mapState(["permissionAgent", "defaultAgentIndex"]),
  },

  created() {
    if (this.permissionAgent) {
      let _this = this;
      this.currentAgent = this.permissionAgent.find(function (item) {
        return item.id == _this.defaultAgentIndex;
      });
      this.handleAjax(this, this.$route.query.id);
    } else {
      let _this = this;
      this.$http
        .post("/mobile/rimsAgentList", {
          username: localStorage.getItem("usermobile"),
        })
        .then(function (response) {
          _this.changePermissionAgent(response.rimsAgent);
          _this.changeDefaultAgentIndex(response.rimsAgent[0].id);
          _this.currentAgent = _this.permissionAgent.find(function (item) {
            return item.id == _this.defaultAgentIndex;
          });
          _this.handleAjax(_this, _this.$route.query.id);
        });
    }
  },
};
</script>
<style scoped lang="less">
.van-button {
  width: 100%;
}
#aaa {
  width: 100vw;
  height: 46px;
}
.van-cell.van-field {
padding: 0;
}
.discolor {
  background-color: #F5F5F5;
}
</style>